// export const drawerWidth = 240


// use drawer with multiple steps
export const drawerWidth = 180

